export const checkVersion = (a?: string, b?: string) => {
  const first = typeof a === 'string' ? a.split('.') : [];
  const second = typeof b === 'string' ? b.split('.') : [];

  if (!first.length || !second.length) {
    return false;
  }

  for (let index = 0; index < first.length; index++) {
    const firstComponent = Number.parseInt(first[index], 10) || 0;
    const secondComponent = Number.parseInt(second[index] || '0', 10) || 0;

    if (firstComponent > secondComponent) {
      return true;
    }

    if (secondComponent > firstComponent) {
      return false;
    }
  }

  return false;
};
